import BpoMainContent from "./BpoCotent";

export default BpoMainContent;